<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-user-tie" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{user.first_name}} {{user.last_name}}</div>
        </template>
    </card-list-item>
</template>

<script>
    import CardListItem from "@/TIER/components/CardListItem";

    export default {
        name: 'ResellerTile',
        components: {CardListItem},
        props: {
            card: {
                required: true
            },
            user: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
